module.exports = __webpack_public_path__ + "static/media/hamburguer.4ae5a644.svg";